import type { ServicePageContentModel } from '../../data'

type ServiceHeroProps = Pick<ServicePageContentModel, 'hero' | 'pageName'>

export function ServiceHero({ hero, pageName }: ServiceHeroProps) {
  const brandClass = hero.partnerBrand?.variant ?? 'neutral'

  return (
    <div className="service-hero">
      <img src={hero.imageSrc} alt={hero.imageAlt} />
      {hero.partnerBrand ? (
        <div className={`service-partner service-partner--${brandClass}`} aria-label={`${hero.partnerBrand.name} ${hero.partnerBrand.descriptor ?? ''}`}>
          <strong>{hero.partnerBrand.name}</strong>
          {hero.partnerBrand.descriptor ? <span>{hero.partnerBrand.descriptor}</span> : null}
        </div>
      ) : null}
      <span className="sr-only">{pageName}</span>
    </div>
  )
}
